import React from 'react';
import ReactTooltip from 'react-tooltip';
export default function InfoIconComponent(props) {
    const { text, id } = props;

    return (
        <>
        {/* <div type="button" className="msg" data-toggle="tooltip" data-placement="top" title={text}>  */}
            


        {/* <div class="tooltip bs-tooltip-top" role="tooltip">
          <div class="arrow"></div>
          <div class="tooltip-inner">
            Some tooltip text!
          </div>
        </div>   */}
        {/* <div type="button" className="msg">
            <p />
            <div className="hidden-msg"><p>{text}</p></div> 
        </div> */}
      <div data-tip data-for={id} className="msg">
        
      </div>

      <ReactTooltip id={id} place="top" type="light" className="msg-wrapper" multiline={true} effect="solid">
        {text}
      </ReactTooltip>
        </>
    )
}